import React from 'react';
import clsx from 'clsx';

export const switcher_110_5 = function(value) {
    return value ? '110%' : '5%';
};

export default function Switch({
    switched,
    onLeftClick,
    leftMessage,
    onRightClick,
    rightMessage,
    switcherAnchorStyler,
    sliderClasses
}) {
    const leftClasses = clsx({ 'ticket-switch-active': !switched });
    const rightClasses = clsx({ 'ticket-switch-active': switched });
    const sliderClass = sliderClasses ? sliderClasses : '';
    let sliderLeft;
    if (switcherAnchorStyler) {
        sliderLeft = switcherAnchorStyler(switched);
    } else {
        sliderLeft = switched ? '70%' : '-70%';
    }
    const onClick = switched ? onLeftClick : onRightClick;
    const uiClass = switched ? 'active' : 'no-active';

    return (
        <div className="flip-exchange-button">
            <div className={'nike-slider ' + sliderClass}>
                <div data-role="fieldcontain">
                    <div className="left">
                        <a className={leftClasses} onClick={onLeftClick}>
                            {leftMessage}
                        </a>
                    </div>
                    <div
                        onClick={onClick}
                        className={
                            'ui-slider ui-slider-switch ui-slider-track ui-shadow-inset ui-bar-inherit ui-corner-all ui-mini ' +
                            uiClass
                        }
                    >
                        <div className="ui-slider-inneroffset">
                            <a
                                className="ui-slider-handle ui-slider-handle-snapping ui-btn ui-shadow"
                                style={{ left: sliderLeft }}
                            />
                        </div>
                    </div>
                    <div className="right">
                        <a className={rightClasses} onClick={onRightClick}>
                            {rightMessage}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}
